import { apiFetch } from "./api";

export function getProfile() {
  return apiFetch("/users/me");
}

export function updateProfile({ full_name }) {
  return apiFetch("/users/me", {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ full_name }),
  });
}

export function changePassword(old_password, new_password) {
  return apiFetch("/users/me/password", {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ old_password, new_password }),
  });
}

export function createUser({ email, password, full_name, role }) {
  return apiFetch("/users/", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password, full_name, role }),
  });
}

export function listUsers() {
  return apiFetch("/users/");
}

export function updateUserRole(id, role) {
  return apiFetch(`/users/${id}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ role }),
  });
}

export function deleteUser(id) {
  return apiFetch(`/users/${id}`, { method: "DELETE" });
}
